import { capitalize } from '@sorrem-client/ui/shared/text';
import { getAllEssenceTypes, type EssencePool } from '@sorrem/shared';
import { EssenceOrb } from '@sorrem-client/ui/components/EssenceOrb';
import styles from './EssenceTally.module.scss';

interface EssenceTallyProps {
    essencePool: EssencePool;
    /** What the essence is, for screen readers, e.g. "Essence carried". */
    ariaLabel: string;
    /** Visible caption before the amounts, for when several tallies sit together. */
    label?: string;
    /** Leaves out types with none, e.g. for what a trade pays. */
    isEmptyHidden?: boolean;
}


/** Essence by type, one line: a dot in the essence color and the amount, named on hover. */
export function EssenceTally({ essencePool, ariaLabel, label, isEmptyHidden = false }: EssenceTallyProps): JSX.Element {
    const tally = (
        <ul className={styles.essenceTally} aria-label={ariaLabel}>
            {getAllEssenceTypes().filter((type) => !isEmptyHidden || essencePool[type] > 0).map((type) => (
                <li key={type} className={styles.entry} title={capitalize(type)}>
                    <EssenceOrb type={type} className={styles.orb} />
                    <span className={styles.amount}>{essencePool[type].toLocaleString()}</span>
                    <span className={styles.name}>{capitalize(type)}</span>
                </li>
            ))}
        </ul>
    );
    if (label === undefined) {
        return tally;
    }
    return (
        <div className={styles.labelledTally}>
            <span className={styles.label} aria-hidden='true'>{label}</span>
            {tally}
        </div>
    );
}
